import { Checkbox } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import './BitwiseGroup.scss';

export interface IBitwisePayload {
  value: 1 | 2 | 4 | 8 | 16 | 32;
  name: string;
  enabled: boolean;
}

export interface IBitwiseGroupProps {
  total: number;
  onChange: (total: number) => void;
  payloads: IBitwisePayload[];
  className?: ClassName;
}

const BitwiseGroup = ({ total, onChange, payloads, className }: IBitwiseGroupProps) => {
  function toggle(checked: boolean, value: number) {
    if (checked) {
      // tslint:disable-next-line: no-bitwise
      onChange(total | value);
    } else {
      // tslint:disable-next-line: no-bitwise
      onChange(total & ~value);
    }
  }

  const classes = classNames('bitwise-group', className);

  return (
    <div className={classes}>
      {payloads.map((payload) => (
        <Checkbox
          key={payload.value}
          value={payload.value}
          label={payload.name}
          onChange={toggle}
          disabled={!payload.enabled}
          // tslint:disable-next-line: no-bitwise
          checked={(total & payload.value) !== 0}
        />
      ))}
    </div>
  );
};

export default BitwiseGroup;
